import { Directive, nextTick } from 'vue';

export default {
  mounted: (el: any) => {
    nextTick(() => el.focus());
  },
} as Directive<any, any>;
